import { defineMessages } from 'react-intl';

export default defineMessages({
	manageProjectsPageTitle: {
		defaultMessage: 'Projects',
		description: 'Help center manage projects page title',
		id: 'manage.projects.page.title',
	},
	manageProjectsPageTitleGalaxia: {
		defaultMessage: 'Spaces',
		description: 'Help center manage spaces page title',
		id: 'manage.projects.page.title-galaxia',
	},
	manageProjectsPageDescription: {
		defaultMessage:
			'Manage your help content effectively by linking projects to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking projects to a help center</link>',
		description: 'Help center manage projects page description',
		id: 'manage.projects.page.description',
	},
	manageProjectsPageDescriptionHelpHub: {
		defaultMessage:
			'Manage spaces linked to your help center to organize help content and show customers only relevant resources.',
		description: 'Help center manage spaces page description',
		id: 'manage.projects.page.description.helphub',
	},
	manageProjectsPageDescriptionGalaxia: {
		defaultMessage:
			'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
		description: 'Help center manage spaces page description',
		id: 'manage.projects.page.description-galaxia',
	},
	// eslint-disable-next-line rulesdir/i18n-unique-message-ids
	manageProjectsPageDescriptionForDefaultHC: {
		defaultMessage:
			'All the projects in your site are always linked to your default help center, the resources will always be available in help center portal sections, virtual service agent, search and recently used request forms. <link>Learn more about projects in help centers</link>',
		description: 'Help center manage projects page description',
		id: 'manage.projects.page.default.hc.description',
	},
	// eslint-disable-next-line rulesdir/i18n-unique-message-ids
	manageProjectsPageDescriptionForDefaultHCGalaxia: {
		defaultMessage:
			'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
		description: 'Help center manage spaces page description',
		id: 'manage.projects.page.default.hc.description-galaxia',
	},
	manageProjectPageToggleForDefaultLinking: {
		defaultMessage: 'Link all new projects to this help center',
		description: 'Toggle label for default linking',
		id: 'manage.projects.page.toggle.default.linking',
	},
	manageProjectPageToggleForDefaultLinkingHelpHub: {
		defaultMessage: 'Link all new projects to this help center',
		description: 'Toggle label for default linking for help center',
		id: 'manage.projects.page.toggle.default.linking.helphub',
	},
	manageProjectPageToggleForDefaultLinkingGalaxiaHelpHub: {
		defaultMessage: 'Link all new spaces to this help center',
		description: 'Toggle label for default linking for help center with Galaxia renaming',
		id: 'manage.projects.page.toggle.default.linking.galaxia.helphub',
	},
	manageProjectPageToggleForDefaultLinkingGalaxia: {
		defaultMessage: 'Link all new spaces to this help center',
		description: 'Toggle label for default linking',
		id: 'manage.projects.page.toggle.default.linking-galaxia',
	},
	linkedFilterLabel: {
		defaultMessage: 'Linked projects',
		description: 'Label for linked dropdown item',
		id: 'manage.projects.page.linked.dropdown.item.label',
	},
	linkedFilterLabelGalaxia: {
		defaultMessage: 'Linked spaces',
		description: 'Label for linked dropdown item',
		id: 'manage.projects.page.linked.dropdown.item.label-galaxia',
	},
	unlinkedFilterLabel: {
		defaultMessage: 'Unlinked projects',
		description: 'Label for unlinked dropdown item',
		id: 'manage.projects.page.unlinked.dropdown.item.label',
	},
	unlinkedFilterLabelGalaxia: {
		defaultMessage: 'Unlinked spaces',
		description: 'Label for unlinked dropdown item',
		id: 'manage.projects.page.unlinked.dropdown.item.label-galaxia',
	},
	searchProjectsPlaceholder: {
		defaultMessage: 'Search for projects',
		description: 'Placeholder for search projects input',
		id: 'manage.projects.page.search.placeholder',
	},
	searchProjectsPlaceholderGalaxia: {
		defaultMessage: 'Search for spaces',
		description: 'Placeholder for search spaces input',
		id: 'manage.projects.page.search.placeholder-galaxia',
	},
	errorTitle: {
		defaultMessage: 'Something went wrong',
		description: 'Error title shown on the manage projects page when an unexpected error occurs',
		id: 'manage.projects.page.error.title',
	},
	errorDescription: {
		defaultMessage: 'Refresh the page and try again',
		description: 'Error message body on the manage projects page prompting the user to retry',
		id: 'manage.projects.page.error.description',
	},
});
